/**
 * Shared compliance score color scheme
 * - < 50%: Red (non-compliant)
 * - 50-70%: Orange (needs attention)
 * - 70-80%: Yellow (approaching compliance)
 * - 80-90%: Yellow-Green (nearly compliant)
 * - 90%+: Green (compliant)
 */

export interface ComplianceColorStyle {
  backgroundColor: string;
  color: string;
}

export function getComplianceScoreColors(value?: number): ComplianceColorStyle {
  if (value === undefined || value === null) {
    return { backgroundColor: "#6c757d", color: "#ffffff" };
  }

  if (value < 50) {
    return { backgroundColor: "#dc3545", color: "#ffffff" };
  }

  if (value < 70) {
    return { backgroundColor: "#fd7e14", color: "#ffffff" };
  }

  if (value < 80) {
    return { backgroundColor: "#ffc107", color: "#212529" };
  }

  if (value < 90) {
    return { backgroundColor: "#9ACD32", color: "#212529" };
  }

  return { backgroundColor: "#198754", color: "#ffffff" };
}

/**
 * Get compliance status label
 */
export function getComplianceStatusLabel(value?: number): string {
  if (value === undefined || value === null) {
    return "Unknown";
  }

  if (value >= 90) {
    return "Compliant";
  }

  if (value >= 70) {
    return "At Risk";
  }

  return "Non-Compliant";
}
